import {Accordion, AccordionDetails, AccordionSummary, Checkbox, Grid, Stack, Typography} from "@mui/material";
import {ItemPaper} from "./WeaponBuilder";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoTooltip from "../components/InfoTooltip";
import CleanerIcon from "../assets/Wht-Cleaners-IncendiaryRounds.webp"
import PhantomIcon from "../assets/Wht-Phantoms-Fortified.webp"
import Image from 'react-bootstrap/Image';
import MultipliersSettings from "./settings/MultiplierSettings";

export const GRAPH_SETTINGS = {
    cleanerDamage: false,
    rangePenalty: 0,
    enemyHealth: 100,
    multipliers: {head: 0}
}

const CLEANER_DAMAGE_TOOLTIP = "Includes 10 incendiary tick damage when calculating STK and TTK (does not include the tick time)"
const CLEANER_RANGE_TOOLTIP = "Includes 10% damage range reduction"
const PHANTOM_HEALTH_TOOLTIP = "Uses 120 health for calculating STK and TTK"

const CLEANER_DAMAGE = 10;
const CLEANER_RANGE_REDUCTION = 0.1;
const PHANTOM_HEALTH = 120;

const GridItem = ({image, title, tooltip, checked, onCheck}) => {
    return (
        <Grid item xs={12} md={6}>
            <Stack direction='row' alignItems='center' sx={{ml: {xs: '15px', md: '25px'}}}>
                {image}
                <Typography variant='h7' sx={{marginBottom: '3px'}}>
                    {title}
                </Typography>
                <InfoTooltip text={tooltip}/>
                <Checkbox
                    sx={{
                        padding: '5px',
                        color: 'white',
                        '&.Mui-checked': {
                            color: 'white',
                        },
                    }}
                    size='small'
                    checked={checked}
                    onChange={onCheck}
                />
            </Stack>
        </Grid>
    )
};


function AdvancedSettings({settings, setSettings}) {

    const handleCleanerDamage = (event) => {
        setSettings({...settings, cleanerDamage: event.target.checked ? CLEANER_DAMAGE : 0, rangePenalty: event.target.checked ? CLEANER_RANGE_REDUCTION : 0});
    };
    const handleCleanerRange = (event) => {
        setSettings({...settings, rangePenalty: event.target.checked ? CLEANER_RANGE_REDUCTION : 0});
    };
    const handlePhantomHealth = (event) => {
        setSettings({...settings, enemyHealth: event.target.checked ? PHANTOM_HEALTH : 100});
    };
    const handleAdsTtk = (event) => {
        setSettings({...settings, adsTtk: event.target.checked});
    };
    const handleStfTtk = (event) => {
        setSettings({...settings, stfTtk: event.target.checked});
    };
    const handleMultiplierValue = (newValue) => {
        const newMultipliers = {...settings.multipliers}
        newMultipliers.head = Math.min(Math.max(0, newValue), 15)
        setSettings({...settings, multipliers: newMultipliers})
    };

    return (
        <ItemPaper sx={{padding: 0}}>
            <Accordion elevation={0} disableGutters>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{color: 'white'}}/>}
                    aria-controls="advanced-content"
                    id="advanced-header"
                >
                    <Typography variant='h6'>Advanced</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container sx={{width: {sx: '100%', md: '100%'}}} alignItems='center'>
                        <MultipliersSettings settings={settings} handleMultiplierValue={handleMultiplierValue}/>
                        <GridItem title={"Cleaner incendiary damage:"}
                                  tooltip={CLEANER_DAMAGE_TOOLTIP}
                                  checked={settings.cleanerDamage === CLEANER_DAMAGE}
                                  onCheck={handleCleanerDamage}
                                  image={
                                      <Image
                                          style={{paddingRight: '10px'}}
                                          height='25px'
                                          src={CleanerIcon}
                                          fluid
                                          rounded
                                      />
                                  }
                        />
                        <GridItem title={"Cleaner incendiary range penalty:"}
                                  tooltip={CLEANER_RANGE_TOOLTIP}
                                  checked={settings.rangePenalty === CLEANER_RANGE_REDUCTION}
                                  onCheck={handleCleanerRange}
                        />
                        <GridItem title={"Phantom health:"}
                                  tooltip={PHANTOM_HEALTH_TOOLTIP}
                                  checked={settings.enemyHealth === PHANTOM_HEALTH}
                                  onCheck={handlePhantomHealth}
                                  image={
                                      <Image
                                          style={{paddingRight: '10px', paddingBottom: '5px'}}
                                          height='23px'
                                          src={PhantomIcon}
                                          fluid
                                          rounded
                                      />}
                        />
                        <Grid item xs={12} md={6}/>
                        <GridItem title={"Include ADS Time:"}
                                  tooltip={"Include ADS time when calculating TTK"}
                                  checked={settings.adsTtk}
                                  onCheck={handleAdsTtk}
                        />
                        <GridItem title={"Include Sprint to Fire Time:"}
                                  tooltip={"Include Sprint to Fire time when calculating TTK"}
                                  checked={settings.stfTtk}
                                  onCheck={handleStfTtk}
                        />
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </ItemPaper>
    )
}

export default AdvancedSettings;
